import {
  DAHTCaseloadCategories,
  DAHTDermoscopyRelevance,
  DAHTSkinLesionExperienceCategories,
  DermloopDAHTStudyGroup,
} from '@dermloop/static-values';
import type {
  DAHTCaseloadCategory,
  DAHTRelevance,
  DAHTSkinLesionExperienceCategory,
} from '@dermloop/static-values';
import {
  IsBoolean,
  IsIn,
  IsNotEmpty,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';
export class DAHTUserEnrollmentDto {
  @IsUUID()
  @IsNotEmpty()
  userId: string;

  @IsString()
  @IsNotEmpty()
  firstName: string;

  @IsString()
  @IsNotEmpty()
  lastName: string;

  @IsString()
  @IsNotEmpty()
  countryCode: string;

  @IsOptional()
  @IsUUID()
  genderId?: string;

  @IsString()
  @IsIn(DAHTSkinLesionExperienceCategories.map((v) => v.value))
  @IsNotEmpty()
  skinLesionInterpretationExperienceCategory: DAHTSkinLesionExperienceCategory;

  @IsString()
  @IsIn(DAHTCaseloadCategories.map((v) => v.value))
  @IsNotEmpty()
  caseloadMelanocyticLesionsMonthlyCategory: DAHTCaseloadCategory;

  @IsString()
  @IsIn(DAHTDermoscopyRelevance.map((v) => v.value))
  @IsNotEmpty()
  percievedRelevanceOfDermoscopyImages: DAHTRelevance;

  @IsBoolean()
  @IsNotEmpty()
  formerDermoscopyTraining: boolean;

  @IsBoolean()
  @IsNotEmpty()
  routinelyUseDigitizedSlides: boolean;
}

export class DAHTUserDetailsDto {
  studyGroup?: DermloopDAHTStudyGroup;
  trialEndedDate?: Date;
  created?: Date;
}
